module.exports = __webpack_public_path__ + "img/1.c484a184.jpg";